import { render } from "./ShowLinkDialog.vue?vue&type=template&id=edaadda4"
import script from "./ShowLinkDialog.vue?vue&type=script&lang=js"
export * from "./ShowLinkDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__